import './Modal.scss';
import ModalProps from './ModalProps';
import { Modal as BSModal } from 'react-bootstrap';

const Modal = (props: ModalProps) => {

    const { show, children, handleClose } = props;

    return (
        <BSModal show={show} onHide={handleClose} size={'xl'} centered>
            {children}
        </BSModal>
    )
}

export default Modal;